const KeenSlider = window.KeenSlider

const { setInitialised, useArrows } = window.BAO.Carousel.plugins

class ContentCarousel extends window.BAO.CustomElement() {
  connectedCallback () {
    super.connectedCallback()

    if (this.els.slide.elements.length < 2) return

    this.carousel = this.setupCarousel()
  }

  setupCarousel () {
    return new KeenSlider(
      this.els.slides.element,
      {
        selector: this.els.slide.selector,
        defaultAnimation: {
          duration: 1500,
        },
        loop: false,
        mode: 'snap',
        slides: {
          perView: 1.1,
          spacing: 15,
        },
        breakpoints: {
          '(min-width: 768px)': {
            disabled: this.els.slide.elements.length <= 3,
            slides: {
              perView: 3.05,
              spacing: 20,
            },
          },
        },
      },
      [
        setInitialised(),
        useArrows({
          next: this.externalEls?.next?.element,
          previous: this.externalEls?.previous?.element,
        }),
      ],
    )
  }
}

if (!customElements.get('content-carousel')) {
  customElements.define('content-carousel', ContentCarousel)
}
